import { NavLink } from "react-router-dom";
import {
  Home, TrendingUp, MessageSquare, Target, Wallet, Menu, X,
  LayoutDashboard, Building2, Boxes, Lock, HardHat, Sparkles, Globe2, Settings as SettingsIcon,
} from "lucide-react";
import { useState } from "react";
import { Logo } from "./Logo";

const TABS = [
  { to: "/", icon: Home, label: "Home" },
  { to: "/sales", icon: TrendingUp, label: "Sales" },
  { to: "/nexus-ai", icon: MessageSquare, label: "Vexen AI" },
  { to: "/targets", icon: Target, label: "Targets" },
  { to: "/collection", icon: Wallet, label: "Collection" },
];

const ALL_NAV = [
  { to: "/", icon: LayoutDashboard, label: "Command Center" },
  { to: "/sales", icon: TrendingUp, label: "Sales Intelligence" },
  { to: "/collection", icon: Wallet, label: "Collection Intelligence" },
  { to: "/targets", icon: Target, label: "Target vs Achievement" },
  { to: "/projects", icon: Building2, label: "Project Intelligence" },
  { to: "/inventory", icon: Boxes, label: "Inventory Intelligence" },
  { to: "/blocked", icon: Lock, label: "Blocked Units" },
  { to: "/engineering", icon: HardHat, label: "Engineering Milestone" },
  { to: "/strategic", icon: Sparkles, label: "Strategic Insights" },
  { to: "/market", icon: Globe2, label: "Market Intelligence" },
  { to: "/nexus-ai", icon: MessageSquare, label: "Vexen AI", accent: true },
  { to: "/settings", icon: SettingsIcon, label: "Settings" },
];

export const MobileNav = () => {
  const [drawer, setDrawer] = useState(false);
  return (
    <>
      <nav
        className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-vexen-sidebar text-white border-t border-white/10"
        data-testid="mobile-nav"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      >
        <div className="grid grid-cols-6">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.to === "/"}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-1 py-2 text-[9px] uppercase tracking-wider ${
                  isActive ? "text-amber-400" : "text-slate-400"
                }`
              }
              data-testid={`mobile-nav-${t.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <t.icon size={17} strokeWidth={1.8} />
              <span className="font-mono">{t.label}</span>
            </NavLink>
          ))}
          <button
            onClick={() => setDrawer(true)}
            className="flex flex-col items-center justify-center gap-1 py-2 text-[9px] uppercase tracking-wider text-slate-400 hover:text-white"
            data-testid="mobile-nav-more"
          >
            <Menu size={17} strokeWidth={1.8} />
            <span className="font-mono">More</span>
          </button>
        </div>
      </nav>

      {drawer && (
        <div className="md:hidden fixed inset-0 z-50" data-testid="mobile-drawer">
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setDrawer(false)} />
          <div className="absolute right-0 top-0 bottom-0 w-72 max-w-[85vw] bg-vexen-sidebar text-white flex flex-col">
            <div className="flex items-center justify-between p-4 border-b border-white/10">
              <Logo size={32} withText lightWordmark />
              <button onClick={() => setDrawer(false)} className="text-slate-400 hover:text-white p-1" data-testid="mobile-drawer-close">
                <X size={18} />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto py-2">
              {ALL_NAV.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === "/"}
                  onClick={() => setDrawer(false)}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-3 text-sm transition-colors ${
                      isActive ? "bg-amber-500/20 text-amber-300 font-semibold" : "text-slate-300 hover:bg-white/5"
                    } ${item.accent && "border-l-2 border-amber-500"}`
                  }
                  data-testid={`mobile-drawer-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  <item.icon size={17} strokeWidth={1.7} />
                  <span>{item.label}</span>
                </NavLink>
              ))}
            </div>
            <div className="p-4 text-[10px] uppercase tracking-[0.2em] text-slate-500 font-mono border-t border-white/10">
              © Scitus.ai
            </div>
          </div>
        </div>
      )}
    </>
  );
};
